export default class Word
{
  constructor()
  {
    this._direction = null
    this._row = null
    this._col = null
    this._word = ''
    this._startCell = null
    this._endCell = null
    this._found = false
  }
  
  get startCell() { return this._startCell }
  set startCell(startCell) { this._startCell = startCell }

  get endCell() { return this._endCell }
  set endCell(endCell) { this._endCell = endCell }

  get row() { return this._row }
  set row(row) { this._row = row }

  get col() { return this._col }
  set col(col) { this._col = col }

  get direction() { return this._direction }
  set direction(direction) { this._direction = direction }

  get word() { return this._word }
  set word(word) { this._word = word }

  get found() { return this._found }
  set found(found) { this._found = Boolean(found) }

}

